import { createFileRoute } from '@tanstack/react-router'

import { tambahPesananSearchSchema } from '@/features/order-management/mode'
import { TambahPesananPage } from '@/features/order-management/components/TambahPesananPage'
import { groupsInfiniteQueryOptions } from '@/features/group/queries'
import { useUser } from '@/features/auth/store'

export const Route = createFileRoute('/_authed/order-management/new')({
  validateSearch: tambahPesananSearchSchema,
  loader: ({ context }) =>
    context.queryClient.infiniteQuery(groupsInfiniteQueryOptions()).catch(() => undefined),
  component: RouteComponent,
})

function RouteComponent() {
  const user = useUser()
  const { mode, returnTo, returnSearch } = Route.useSearch()
  return (
    <TambahPesananPage key={user?.id} mode={mode} returnTo={returnTo} returnSearch={returnSearch} />
  )
}
